














































































































































































































































import {
  Vue,
  Component,
  Watch,
  Prop
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import Address from "@/employee/components/shared/Address.vue";
import * as _ from "lodash";
import moment from "moment";
import {
  FetchState,
  PlanType,
  ContactInformation,
  InvestmentCustodian,
} from "@/shared/types";
import NoAccountMessage from "@/employee/components/NoAccountMessage.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import LobAddressSuggestionModal from "../../../shared/components/LobAddressSuggestionModal.vue";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserPlanStore } from "@/employee/store/userPlan";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useThemeStore } from "@/shared/store/theme";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

const initialState: ContactInformation = {
  firstName: "",
  middleInitial: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  mobilePhoneNumber: "",
  dateOfBirth: "",
  isMailingSameAsPhysical: false,
  mailingAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
  },
  physicalAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
  },
  lastFourSsn: "",
  memberNumber: "",
  lastLogin: "",
  username: ""
};

const passwordInitialState = {
  currentPassword: "",
  newPassword: "",
  newPasswordVerify: ""
};

@Component({
  components: {
    Address,
    Button,
    Checkbox,
    NoAccountMessage,
    Input,
    SettingsNavigation,
    SettingsHeader,
    GenericLoadingSpinner,
    LobAddressSuggestionModal
  }
})
export default class MyProfileEdit extends Vue {
  $validator: Validator;

  portalCustomizationStore = usePortalCustomizationStore();
  userBankAccountStore = useUserBankAccountStore();
  contactInfoStore = useContactInfoStore();
  partnerPortalStore = usePartnerPortalStore();
  userPlanStore = useUserPlanStore();
  custodianSettingsStore = useCustodianSettingsStore();
  drivewealthStore = useDrivewealthStore();
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  themeStore = useThemeStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  @Prop({ required: false })
  dwAccountId: number;

  isBankMasked = true;
  isProfileSaved = false;
  mailingCanBeCopiedToPhysical = true;
  isSubmitting = false;
  formModel: ContactInformation = { ...initialState };
  showEmailChangeModal = false;
  effectiveDateInput = null;
  accountTypeInput = null;
  passwordFormModel = { ...passwordInitialState };
  editPasswordMode = false;
  updatingPassword = false;
  showPasswordRequirements = false;

  mounted (): void {
    this.userPlanStore.getPlanType();
    this.contactInfoStore.getContactInformation();
    this.initializeFromStateValue();
    this.partnerPortalStore.getPartnerPortalStatus();
    this.custodianSettingsStore.getCustodianSettings();
    this.investmentThresholdStore.loadInvestmentThresholds({});
    if (this.partnerPortalStore.hasPortalAccess) {
      this.userBankAccountStore.loadBankAccountState();
    }
    this.loadDrivewealthIfNeeded();
  }

  cancelPendingChange () {
    this.effectiveDateInput = moment().format("MM/DD/YYYY");
    this.accountTypeInput = this.userPlanStore.userPlan.planType === PlanType.Family ? PlanType.Individual
      : PlanType.Family;
    this.onSubmit();
  }

  get newPasswordVerifyValidation () {
    return {
      required: !!this.passwordFormModel.newPassword,
      confirmed: !!this.passwordFormModel.newPasswordVerify && this.passwordFormModel.newPassword
    };
  }

  get enableEffectiveDateInputs () {
    return this.accountTypeChanged;
  }

  @Watch("partnerPortalStore.hasPortalAccess")
  getBankAccountInfo () {
    if (this.partnerPortalStore.hasPortalAccess) {
      this.userBankAccountStore.loadBankAccountState();
    }
  }

  get disablePlanTypeDropDown () {
    return this.userPlanStore.planTypePendingChange;
  }

  get showEffectiveDateInput () {
    return this.disablePlanTypeDropDown || this.enableEffectiveDateInputs;
  }

  get effectiveDateChange () {
    if (this.effectiveDateInput) {
      return this.effectiveDateInput;
    }
    return this.userPlanStore.userPlan.planTypeChangeEffectiveDate;
  }

  set effectiveDateChange (value) {
    this.effectiveDateInput = value;
  }

  get bankAccountLoaded () {
    return this.userBankAccountStore.fetchState === FetchState.Loaded;
  }

  get showBankAccount () {
    return this.bankAccountLoaded && this.userBankAccountStore.accountNumber;
  }

  get planType () {
    if (this.accountTypeInput) {
      return this.accountTypeInput;
    }
    return this.userPlanStore.userPlan.planType;
  }

  set planType (value) {
    this.accountTypeInput = value;
  }

  get hsaAccountSelectOptions () {
    return [
      {
        text: "Individual",
        value: PlanType.Individual
      },
      {
        text: "Family",
        value: PlanType.Family
      }
    ];
  }

  get isFormLocked () {
    return !this.partnerPortalStore.hasPortalAccess;
  }

  get validateEffectiveDate () {
    return this.accountTypeChanged ? "required" : "";
  }

  get initialEmailAddress () {
    if (!this.contactInfoStore.contactInformation || !this.contactInfoStore.contactInformation.email) {
      return null;
    }

    return this.contactInfoStore.contactInformation.email.toLowerCase();
  }

  get showPhysicalAddress () {
    return this.mailingCanBeCopiedToPhysical === false || this.formModel.isMailingSameAsPhysical === false;
  }

  get shouldShowPhysicalAddressSameAsMailing () {
    return this.mailingCanBeCopiedToPhysical;
  }

  get bankAccount () {
    if (this.bankAccountLoaded && this.isBankMasked) {
      return "•".repeat(this.userBankAccountStore.accountNumber.length);
    }

    return this.userBankAccountStore.accountNumber;
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    this.formModel = clonedModel;
    this.contactInfoStore.clearValidationErrors();
  }

  initializeFromStateValue () {
    const contactInformation = this.contactInfoStore.contactInformation;
    if (this.contactInfoStore.contactInformationState === FetchState.Loaded && !contactInformation) {
      this.cloneToCurrentModel(initialState);
    } else if (contactInformation) {
      this.cloneToCurrentModel(contactInformation);
    }
  }

  @Watch("contactInfoStore.contactInformation")
  onPlanStateChanged () {
    this.initializeFromStateValue();
  }

  mailingAddressIsPo (isPoBox) {
    if (isPoBox) {
      this.formModel.isMailingSameAsPhysical = false;
    }

    this.mailingCanBeCopiedToPhysical = !isPoBox;
  }

  get isLoading () {
    return this.contactInfoStore.contactInformationState !== FetchState.Loaded;
  }

  get accountTypeChanged () {
    return this.accountTypeInput !== null &&
      this.accountTypeInput !== this.userPlanStore.userPlan.planType;
  }

  get effectiveDateChanged () {
    return this.effectiveDateInput !== null &&
      this.effectiveDateInput !== this.userPlanStore.userPlan.planTypeChangeEffectiveDate;
  }

  toggleBankMask () {
    this.isBankMasked = !this.isBankMasked;
  }

  toggleEditPassword () {
    this.editPasswordMode = true;
  }

  togglePasswordRequirements () {
    this.showPasswordRequirements = !this.showPasswordRequirements;
  }

  emailAddressChanged () {
    return this.formModel.email.toLowerCase() !== this.initialEmailAddress;
  }

  copyMailingAddressToPhysical () {
    if (this.formModel.isMailingSameAsPhysical) {
      this.formModel.physicalAddress = { ...this.formModel.mailingAddress };
    }
  }

  onSubmit () {
    if (this.isSubmitting) return;

    this.isProfileSaved = false;
    this.isSubmitting = true;
    this.copyMailingAddressToPhysical();

    this.$validator
      .validate()
      .then(result => {
        if (result) return this.submitValidated();
      })
      .finally(() => this.isSubmitting = false);
  }

  handleSaveContactInformation () {
    return this.contactInfoStore.saveContactInformation(this.formModel).then(() => {
      const emailAddressChanged = this.emailAddressChanged();
      this.isProfileSaved = true;
      if (this.custodianSettingsStore.contactDetailsSetAtBank) {
        this.notifierStore.setSuccess("The changes should be reflected within 2 business days");
      } else {
        this.notifierStore.setSuccess("Your profile has been updated");
      }

      if (emailAddressChanged) {
        this.showEmailChangeModal = true;
      }
    }).catch(() => {/* noop */
    }).finally(() => this.isSubmitting = false);
  }

  async submitValidated () {
    if (this.accountTypeChanged || this.effectiveDateChanged) {
      this.userPlanStore.updatePlanType({
        planType: this.accountTypeInput,
        planTypeChangeEffectiveDate: this.effectiveDateChange
      });
    }

    if (this.useLobApi && !this.contactInfoStore.mailingAddressValidated) {
      return this.contactInfoStore.validateAddress(this.formModel.mailingAddress).then(() => {
        this.formModel.mailingAddress = { ...this.contactInfoStore.lobAddressSuggestion.suggestedAddress };
        this.contactInfoStore.setMailingAddressValidation(true);
        return this.handleSaveContactInformation();
      }).catch(() => {/* noop */
      });
    }
    return this.handleSaveContactInformation();
  }

  onLobAddressSuggestionModalClosed (value: number) {
    this.contactInfoStore.toggleLobSuggestionModal(false);
    if (value > 0) {
      this.isSubmitting = true;
      if (value === 2) {
        this.formModel.mailingAddress = { ...this.contactInfoStore.lobAddressSuggestion.suggestedAddress };
      }
      this.contactInfoStore.setMailingAddressValidation(true);
      this.handleSaveContactInformation();
    }
  }

  handleAddressValidation (value: boolean, formId: string) {
    if (formId === "mailingAddress") {
      this.contactInfoStore.setMailingAddressValidation(value);
    }
  }

  get useLobApi () {
    return this.featureFlagStore.flags.lobAddressValidationIsEnabled;
  }

  closePopup () {
    this.showEmailChangeModal = false;
  }

  get isSubmitEnabled () {
    return !this.isSubmitting && this.isValid && !this.isFormLocked;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  loadDrivewealthIfNeeded () {
    if (!this.investmentThresholdStore.isDrivewealthInvestmentProvider) {
      return;
    }
    if (this.dwAccountId) {
      this.drivewealthStore.getAccountSummaryV2({ dwAccountId: this.dwAccountId });
    } else {
      this.drivewealthStore.loadAccountSummary();
    }
  }

  get showInvestmentAccount () {
    return this.drivewealthStore.accountSummaryLoaded && this.investmentAccountId;
  }

  get investmentAccountId () {
    if (this.investmentThresholdStore.isDrivewealthInvestmentProvider &&
      this.drivewealthStore.accountSummaryLoaded) {
      return this.drivewealthStore.accountSummary.accountNumber;
    }
    return null;
  }

  get investmentAccountLabel (): string {
    return `${this.investmentThresholdStore.investmentProviderName} Account Number`;
  }

  updatePassword () {
    if (this.updatingPassword) {
      return;
    }

    this.updatingPassword = true;

    this.$validator
      .validate()
      .then(result => {
        if (!result) {
          return Promise.reject();
        }

        return this.userStore.changePassword({
          currentPassword: this.passwordFormModel.currentPassword,
          newPassword: this.passwordFormModel.newPassword
        });
      })
      .then(() => {
        this.editPasswordMode = false;
        this.passwordFormModel = { ...passwordInitialState };
      })
      .catch(() => {/* noop */
      })
      .finally(() => {
        this.updatingPassword = false;
      });
  }

  cancelPasswordUpdate () {
    this.updatingPassword = false;
    this.editPasswordMode = false;
    this.passwordFormModel = { ...passwordInitialState };
    this.showPasswordRequirements = false;
  }

  togglePasswordMask (inputId: string) {
    const passwordField = document.getElementById(inputId);

    if (passwordField.getAttribute("type") === "password") {
      passwordField.setAttribute("type", "text");
    } else {
      passwordField.setAttribute("type", "password");
    }
  }
}
